import { Box, Modal } from '@mui/material';
import React, { useState } from 'react';
import Login from '../../../pages/Authentication/Login/Login.component';
import UserTypeSelector from '../../UserTypeSelector/UserTypeSelector.component';
import CSCOwnerAuth from '../../CSCOwnerAuth/CSCOwnerAuth.component';
import './LoginModal.styles.scss';

const loginModalContainerSx = (theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: theme.tokens.radius.sm,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 48px)',
    boxShadow: theme.tokens.shadows.modal,
});

// ─── LoginModal ───────────────────────────────────────────
// userType: null → shows UserTypeSelector (first screen)
//           'customer' → shows existing Login (unchanged)
//           'csc-owner' → shows CSCOwnerAuth (new flow)

const LoginModal = ({ openLoginModal, setOpenLoginModal }) => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [displayName, setDisplayName] = useState(null);
    const [userType, setUserType] = useState(null);

    const closeModal = () => {
        setOpenLoginModal(false);
        setUserType(null);
    };

    const handleUserTypeSelect = (type) => {
        setUserType(type);
    };

    const handleBack = () => {
        setUserType(null);
    };

    return (
        <Modal
            className="login-modal"
            open={openLoginModal}
            onClose={closeModal}
        >
            <Box sx={loginModalContainerSx}>

                {/* ── Step 1: choose account type ── */}
                {userType === null && (
                    <UserTypeSelector
                        onSelect={handleUserTypeSelect}
                        onClose={closeModal}
                    />
                )}

                {/* ── Step 2a: existing customer login (zero changes) ── */}
                {userType === 'customer' && (
                    <Login
                        setOpen={closeModal}
                        setIsUserLoggedIn={setIsUserLoggedIn}
                        setUserInfo={setUserInfo}
                        setDisplayName={setDisplayName}
                        onBack={handleBack}
                    />
                )}

                {/* ── Step 2b: CSC owner login / register ── */}
                {userType === 'csc-owner' && (
                    <CSCOwnerAuth
                        onClose={closeModal}
                        onBack={handleBack}
                    />
                )}

            </Box>
        </Modal>
    );
};

export default LoginModal;
